import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { StatisticsContainer } from './style';
import { DASHBOARD_INFO_GET } from '../../redux/actions/dashboard';
import { CourseProgress, Text } from '../../../ui/atoms';
import EventsList from '../EventsList';
import Tabs from '../../../ui/atoms/Tabs';
import { Container } from '../../../ui/gridSystem';
import ModalLeaveCourse from '../../../ui/atoms/Modals/ModalLeaveCourse';
import { withMediaQueries } from '../../hoc/withMediaQueries';
import { COURSE_CATEGORIES_GET } from '../../redux/actions/courselist';
import ModalSurvey from '../../../ui/atoms/Modals/ModalSurvey';
import LastCoursesResults from './LastCoursesResults';
import CompletedCoursesResults from './CompletedCoursesResults';
import EmptyCoursesResults from './EmptyCoursesResults';

const defaultTabs = [
  { value: 'empty', label: 'Percorsi formativi da iniziare' },
  { value: 'active', label: 'Percorsi formativi attivi' },
  { value: 'completed', label: 'Storico percorsi formativi' },
];

const Dashboard = ({
  getDashboardInfo,
  completion_status,
  emptyCourses,
  lastCourses,
  completedCourses,
  getCategories,
}) => {
  const [tabs, setTabs] = useState(defaultTabs);
  const [activeTab, setActiveTab] = useState('empty');
  const [firstRender, setFirstRender] = useState(true);

  useEffect(() => {
    window.scrollTo(0, 0);
    getDashboardInfo();
    getCategories();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const newTabs = [...defaultTabs];
    newTabs[0].items = emptyCourses?.pager?.total_items || 0;
    newTabs[1].items = lastCourses?.pager?.total_items || 0;
    newTabs[2].items = completedCourses?.pager?.total_items || 0;
    setTabs(newTabs);
  }, [emptyCourses, lastCourses, completedCourses]);

  useEffect(() => {
    if (lastCourses?.length && firstRender) {
      setFirstRender(false);
      setActiveTab('empty');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lastCourses]);

  const onChangeTab = ({ value }) => {
    setActiveTab(value);
  };

  return (
    <>
      <Container>
        <Text type="h1" mb={24}>
          I miei progressi
        </Text>
        <StatisticsContainer>
          {typeof completion_status?.completed === 'number' &&
            typeof completion_status?.incomplete === 'number' && (
              <div>
                <Text type="h2" mb={24}>
                  Statistiche
                </Text>
                <CourseProgress
                  data={{
                    total_courses:
                      completion_status.completed +
                      completion_status.incomplete,
                    completed: completion_status?.completed,
                    in_progress: completion_status?.incomplete,
                  }}
                  mandatory={completion_status?.mandatory}
                />
              </div>
            )}
          <div>
            <Text type="h2" mb={24}>
              Calendario
            </Text>
            <EventsList />
          </div>
        </StatisticsContainer>
        {/* TABS */}
        <Tabs tabs={tabs} selected={tabs[0]} onChange={onChangeTab} />
        <div className={activeTab !== 'empty' ? 'd-none' : ''}>
          <EmptyCoursesResults active={activeTab === 'empty'} />
        </div>
        <div className={activeTab !== 'active' ? 'd-none' : ''}>
          <LastCoursesResults active={activeTab === 'active'} />
        </div>
        <div className={activeTab !== 'completed' ? 'd-none' : ''}>
          <CompletedCoursesResults active={activeTab === 'completed'} />
        </div>
      </Container>
      <ModalLeaveCourse />
      <ModalSurvey />
    </>
  );
};

Dashboard.propTypes = {
  // HOC (connect, state)
  completion_status: PropTypes.object,
  emptyCourses: PropTypes.object,
  lastCourses: PropTypes.object,
  completedCourses: PropTypes.object,

  // HOC (connect, dispatch)
  getDashboardInfo: PropTypes.func.isRequired,
  getCategories: PropTypes.func.isRequired,
};

export default compose(
  connect(
    (state) => {
      const {
        filters,
        completion_status,
        monthly_completed,
        emptyCourses,
        lastCourses,
        completedCourses,
        pager,
      } = state.dashboard;

      const userName = state.user;
      return {
        completion_status,
        monthly_completed,
        userName,
        emptyCourses,
        lastCourses,
        completedCourses,
        filters,
        pager,
      };
    },
    (dispatch) => ({
      getDashboardInfo: () => dispatch({ type: DASHBOARD_INFO_GET._REQUEST }),
      getCategories: () => dispatch({ type: COURSE_CATEGORIES_GET._REQUEST }),
    })
  ),
  withMediaQueries
)(Dashboard);
